import React from 'react';
import DesktopListDetail from './DesktopListDetail';

export default function ListDetail() {
  return <DesktopListDetail />;
}
